import { useLanguageStore } from "~/store/languageStore";
import { useI18nStore } from "~/store/i18nStore";

export const getLocalizedName = (localizedValues) => {
  const languageStore = useLanguageStore();
  const { getUserLanguage: lang } = storeToRefs(languageStore);

  return (
    localizedValues[lang.value.name] ??
    Object.values(localizedValues).find((value) => null !== value)
  );
};

export const getLocalizedRouteName = (routeName) => {
  const languageStore = useLanguageStore();
  const { getLocalizedRoute } = storeToRefs(languageStore);

  return getLocalizedRoute.value(routeName);
};

export const _T = (key) => {
  return useI18nStore().getTranslation(key);
};
